/** Per-event push reminder timings (excludes "off" — use empty selection for no reminders). */
export const EVENT_REMINDER_OPTIONS: { value: string; label: string }[] = [
  { value: "2_days_before_at_19:00", label: "2 days before at 19:00" },
  { value: "1_day_before_at_19:00", label: "1 day before at 19:00" },
  { value: "1_hour_before", label: "1 hour before" },
  { value: "5_minutes_before", label: "5 minutes before" },
  { value: "at_event_start", label: "When the event starts" },
];

/** Labels for legacy modes still stored on older notices (not offered in the picker). */
export const LEGACY_EVENT_REMINDER_LABELS: Record<string, string> = {
  "1_day_before_at_15:00": "1 day before at 15:00",
  "2_days_before_at_15:00": "2 days before at 15:00",
};

export function eventReminderLabel(mode: string): string {
  const fromOptions = EVENT_REMINDER_OPTIONS.find((o) => o.value === mode);
  if (fromOptions) return fromOptions.label;
  return LEGACY_EVENT_REMINDER_LABELS[mode] ?? mode;
}

export const DEFAULT_EVENT_REMINDER_MODES = [
  "1_day_before_at_19:00",
  "at_event_start",
];
